// CDN-hosted marketing videos. Sibling to assets.ts; videos differ in needing a
// poster + one or more encodes, so they live in their own typed map.
import { CDN_BASE_URL } from '../cdn';
export const VIDEOS = {
    splashHome: {
        poster: `${CDN_BASE_URL}/home/splashPoster.png`,
        sources: [{ src: `${CDN_BASE_URL}/home/splash.mp4`, type: 'video/mp4' }],
        durationSeconds: 8,
        aspectRatio: 9 / 16,
    },
};
//# sourceMappingURL=videos.js.map